import { accessRole } from "../../../../helpers/access_role"
import { config } from "../../../../helpers/config_global"
import React, { Fragment, useState, useRef } from "react"
import classnames from "classnames"
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Modal, ModalBody, ModalFooter, ModalHeader, Spinner
} from "reactstrap"

import { Link } from "react-router-dom"

import TableActiveComponent from './Components/TableActiveComponent'
import TableInactiveComponent from './Components/TableInactiveComponent'

const IndexView = props => {

    const [activeTab, setactiveTab] = useState("1")    
    const [modal, setModal] = useState(false)
    const activeRef = useRef();
    const inactiveRef = useRef();

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const reloadInactiveRef = () => inactiveRef.current.setTokenAPI()

    const toggleModal = () => setModal(!modal)

    function toggle(tab) {
        if (activeTab !== tab) {
            setactiveTab(tab)
        }
    }

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col className="col-12">
                        <Card>
                            <CardBody>
                                <div className="float-end">
                                    {/*  */}
                                </div>
                                <CardTitle>Standar Kompetensi</CardTitle>
                                <CardSubtitle>List Standar Kompetensi</CardSubtitle>
                                <hr />
                                <TableActiveComponent ref={activeRef} handleInactiveSuccess={reloadInactiveRef}/>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>

            <Modal
                isOpen={modal}
                role="dialog"
                autoFocus={true}
                centered={true}
                className="exampleModal"
                tabIndex="-1"
                toggle={() => {
                    setModal(!modal)
                }}
            >
                <div className="modal-content">
                <ModalHeader
                    toggle={() => {
                        setModal(!modal);
                    }}
                >
                    Export
                </ModalHeader>
                <ModalBody>
                    
                </ModalBody>
                <ModalFooter>
                    <Button
                        type="button"
                        color="secondary"
                        onClick={() => {
                            setModal(!modal);
                        }}
                    >
                    Kembali
                    </Button>
                </ModalFooter>
                </div>
            </Modal>

        </Fragment>
    )
}

export default IndexView
